import React from "react";
import "./Payment_Failed_Modal.css";
import Failed_Lottie from "../../animation/Failed_Lottie/Failed_Lottie.json";

function Payment_Failed_Modal({ successText, ...props }) {
  return (
    <>
      <section className="Success_modal Payment_Success_Modal">
        <Failed_Lottie successText="Order Falied" />
      </section>
    </>
  );
}

export default Payment_Failed_Modal;
